interface IData {
  event: string;
  url: string;
  type: string;
  status: string;
}

export const linksHandler = (
  editor: any,
  lastRange: Range | null,
  selectedText: string | null,
  data: IData,
) => {
  const selection = window.getSelection();
  if (!selection) return;

  const { url, event, type, status } = data;

  if (selection && lastRange) {
    selection.removeAllRanges();
    selection.addRange(lastRange);
  }

  if (selection.focusNode && !selectedText) {
    if (selection.focusNode.parentElement instanceof HTMLElement) {
      let aEl: HTMLElement | null = null;
      if (selection.focusNode.parentElement.nodeName === 'A') {
        aEl = selection.focusNode.parentElement;
      } else aEl = selection.focusNode.parentElement.closest('a');

      if (aEl) {
        if (status === 'remove') {
          const range = new Range();
          range.selectNode(aEl);
          selection.removeAllRanges();
          selection.addRange(range);
        } else {
          const sanitized =
            type === 'anchor'
              ? 'javascript:void(0);'
              : url.startsWith('http')
              ? url
              : `https://${url}`;

          aEl.setAttribute('href', sanitized);
          if (type === 'anchor') {
            aEl.setAttribute('target', '_blank');
            aEl.setAttribute('data-anchor-trigger', url);
          } else {
            if (event) {
              aEl.setAttribute('data-analytics-click-event', event);
            }
          }
          return;
        }
      }
    }
  }

  editor.link.remove();
  removeLink(selection);

  if (!url || status === 'remove' || !selectedText) return;

  const sanitized =
    type === 'anchor' ? 'javascript:void(0);' : url.startsWith('http') ? url : `https://${url}`;
  if (selection && lastRange) {
    const link = `<a 
            href="${sanitized}" 
            ${event && type !== 'anchor' ? 'data-analytics-click-event="' + event + '"' : ''} 
            ${type === 'anchor' ? '' : 'target="_blank"'}
            ${type === 'anchor' ? 'data-anchor-trigger="' + url + '"' : ''}
        >${selectedText}</a>`;
    selection.toString();
    const range = selection.getRangeAt(0);
    range.deleteContents();
    range.insertNode(document.createRange().createContextualFragment(link));
  }
};

export const getLinkValues = (el: HTMLElement) => {
  const isLinkActive = el.nodeName !== 'A' ? el.closest('a') : true;
  if (!isLinkActive) {
    return {
      type: 'hyperlink',
      event: '',
      url: '',
      status: 'create',
    };
  }
  if (isLinkActive instanceof HTMLElement) el = isLinkActive;

  const url = el.getAttribute('href');
  const anchor = el.getAttribute('data-anchor-trigger');
  return {
    type: url ? url.startsWith('http') ? 'hyperlink' : 'anchor' : 'anchor',
    event: el.getAttribute('data-analytics-click-event') || '',
    url: url ? url.replace('javascript:void(0);', '') : `#${anchor}`,
    status: 'update',
  };
};

const removeLink = (selection: Selection | null) => {
  if (!selection || !selection.rangeCount) return;
  const container = document.createElement('div');
  for (let i = 0, len = selection.rangeCount; i < len; ++i) {
    container.appendChild(selection.getRangeAt(i).cloneContents());
  }
  const links = container.getElementsByTagName('a');
  for (let i = links.length - 1; i >= 0; --i) {
    const link = links[i];
    const parent = link.parentNode as HTMLElement;
    while (link.firstChild) {
      parent.insertBefore(link.firstChild, link);
    }
    parent.removeChild(link);
  }
  const frag = document.createDocumentFragment();
  const childNodes = container.childNodes;
  for (let i = 0, len = childNodes.length; i < len; ++i) {
    frag.appendChild(childNodes[i].cloneNode(true));
  }
  selection.getRangeAt(0).deleteContents();
  selection.getRangeAt(0).insertNode(frag);
};
